export enum CurrencyRateSourceEnum {
  ECB = "ecb",
}
